module.exports = import("https://magaluentregas.com.br/mle-landing-page/assets/remoteEntry.js");